import { render, staticRenderFns } from "./ThrowShipmentAbsence.vue?vue&type=template&id=8606bbd4&scoped=true&"
import script from "./ThrowShipmentAbsence.vue?vue&type=script&lang=js&"
export * from "./ThrowShipmentAbsence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8606bbd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDialog,VForm})
